import { NgModule } from '@angular/core';
import { ExtraOptions, Routes, Router, RouterModule, NavigationError } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { filter } from 'rxjs/operators';

import { FeatureGuard } from 'projects/shared/src/lib/authentication/feature.guard';
import { AuthGuard } from 'projects/shared/src/lib/authentication/auth.guard';

import { MenuService } from 'projects/shared/src/lib/services/menu.service';

import { environment } from '@environment';
import { HomeComponent } from './pages/home/home.component';
import { AccountingReportsComponent } from './pages/accounting-reports/accounting-reports.component';
import { ManagementReportsComponent } from './pages/management-reports/management-reports.component';
import {OtherReportsComponent} from "./pages/other-reports/other-reports.component";
import {CustomerReportsComponent} from "./pages/customer-reports/customer-reports.component";
import {EndOfShiftReportsComponent} from "./pages/end-of-shift-reports/end-of-shift-reports.component";
import {PsManagementReportsComponent} from "./pages/ps-management-reports/ps-management-reports.component";
import {PsOperationsReportsComponent} from "./pages/ps-operations-reports/ps-operations-reports.component";

const routes: Routes = [
    {
        path: '',
        canActivate: [ AuthGuard, FeatureGuard ],
        canActivateChild: [ AuthGuard, FeatureGuard ],
        data: {
            label: 'Reports'
        },
        children: [
            {
                path: '',
                component: HomeComponent,
                data: {
                    label: 'Home',
                    menuOrder: 1,
                    link: 'Reports Home',
                    roles: [ 'scs site user', 'scs admin', 'scs accounting', 'ps site admin', 'ps accounting', 'ps site user', 'payroll', 'it', 'developers' ]
                }
            },
            {
                path: 'accounting',
                component: AccountingReportsComponent,
                data: {
                    label: 'Accounting',
                    menuOrder: 2,
                    link: 'Accounting Reports',
                    roles:[ 'scs admin', 'scs accounting', 'it', 'developers' ]
                }
            },
            {
                path: 'customer',
                component: CustomerReportsComponent,
                data: {
                    label: 'Customer',
                    menuOrder: 3,
                    link: 'Customer Reports',
                    roles:[ 'scs site user', 'scs site admin', 'scs admin', 'scs accounting', 'it', 'developers' ]
                }
            },
            {
                path: 'end-of-shift',
                component: EndOfShiftReportsComponent,
                data: {
                    label: 'End of Shift',
                    menuOrder: 4,
                    link: 'End of Shift Reports',
                    roles:[ 'scs site user', 'scs site admin', 'scs admin', 'scs accounting', 'it', 'developers' ]
                }
            },
            {
                path: 'management',
                component: ManagementReportsComponent,
                data: {
                    label: 'Management',
                    menuOrder: 5,
                    link: 'Management Reports',
                    roles:['scs regional manager', 'scs site admin', 'scs admin', 'it', 'developers']
                }
            },
            {
                path: 'other',
                component: OtherReportsComponent,
                data: {
                    label: 'Other',
                    menuOrder: 6,
                    link: 'Other Reports',
                    roles:[ 'scs site user', 'scs site admin', 'it', 'developers']
                }
            },
            {
                path: 'ps-management',
                component: PsManagementReportsComponent,
                data: {
                    label: 'Pallet Solutions Management',
                    menuOrder: 7,
                    link: 'Pallet Solutions Management',
                    roles:['ps site admin', 'it', 'developers']
                }
            },
            {
                path: 'ps-operations',
                component: PsOperationsReportsComponent,
                data: {
                    label: 'Pallet Solutions Operations',
                    menuOrder: 8,
                    link: 'Pallet Solutions Operations',
                    roles:['ps site admin', 'ps site user', 'it', 'developers']
                }
            },
        ]
    }, {
        // The following three routes are required for MSAL redirects
        path: 'code',
        component: HomeComponent
    }, {
        path: 'error',
        component: HomeComponent
    }, {
        path: 'state',
        component: HomeComponent
    }
];

const routeSettings: ExtraOptions = {
    enableTracing: !environment.isProduction,
    useHash: true,
    relativeLinkResolution: 'legacy'
};

if (window !== window.parent && !window.opener)
    routeSettings.initialNavigation = 'disabled';
else
    routeSettings.initialNavigation = undefined;

@NgModule({
    imports: [
        RouterModule.forRoot(routes, routeSettings)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(private router: Router, private menuService: MenuService, private title: Title) {
        this.menuService.Breadcrumbs.subscribe(breadcrumbs => {
            const segments = breadcrumbs.reduce((aggregate, current) => [ ...aggregate, current.label ], []);

            const t = segments.join(' / ');

            this.title.setTitle(`Vision - ${t}`);
        });

        this.router.events.pipe(filter(evt => evt instanceof NavigationError)).subscribe(event => {
            console.error('Navigation Error');
            console.error({ event });
        });
    }
}
